import React, { useState } from 'react';
import * as API from '../../services/API/back_end';
import Button from '../Button/Button';
import s from './form.module.css';
export default function Form() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [tel, setTel] = useState('');
  const [question, setQuestion] = useState('');

  const onSubmitHandler = e => {
    e.preventDefault();
    const data = JSON.stringify({ name, email, tel, question });
    API.setForm(data).catch(console.log('БІДА!!!'));
    reset();
  };

  const reset = () => {
    setName('');
    setEmail('');
    setTel('');
    setQuestion('');
  };

  const handleChange = e => {
    const { name, value } = e.currentTarget;
    switch (name) {
      case 'name':
        setName(value);
        break;
      case 'email':
        setEmail(value);
        break;
      case 'tel':
        setTel(value);
        break;
      case 'question':
        setQuestion(value);
        break;

      default:
        return;
    }
  };

  return (
    <>
      <div>
        <form className={s.form} onSubmit={onSubmitHandler}>
          <p className={s.text}>
            Якщо у вас з’явилися питання, зателефонуйте нашому спеціалісту або
            надішліть нам лист електронною поштою – ми з радістю дамо відповідь.
          </p>
          <label className={s.label}>
            <p className={s.labelText}>
              Ім'я <span className={s.span}>*</span>
            </p>
            <input
              className={s.input}
              onChange={handleChange}
              value={name}
              /*  pattern="^[a-zA-Zа-яА-Я]+(([' -][a-zA-Zа-яА-Я ])?[a-zA-Zа-яА-Я]*)*$" */
              type="text"
              name="name"
              placeholder="Ваше ім'я"
              title="Імя може складатись тільки з літер, апострофа, тире та пробілів. Наприклад: Пупки Остап, Гуцуленко-Мельник Василь, і т. д."
            />
          </label>
          <label className={s.label}>
            <p className={s.labelText}>
              Email <span className={s.span}>*</span>
            </p>
            <input
              className={s.input}
              onChange={handleChange}
              value={email}
              type="email"
              /* pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2, 4}$"*/
              name="email"
              placeholder="Ваша пошта"
              title="Email повинен містити @" /*доробити*/
            />
          </label>
          <label className={s.label}>
            <p className={s.labelText}>Моб. телефон</p>
            <input
              className={s.input}
              onChange={handleChange}
              value={tel}
              type="tel"
              name="tel"
              placeholder="Ваш телефон"
              title="Наприклад +38 050 111 1234"
            />
          </label>
          <label className={s.label}>
            <p className={s.labelText}>
              Яке у вас питання? <span className={s.span}>*</span>
            </p>
            <textarea
              className={s.inputText}
              onChange={handleChange}
              value={question}
              type="textarea"
              name="question"
              placeholder="Напишіть нам, і ми зв'яжемося з вами як можна швидше"
            />
          </label>
          <Button
            width={'160px'}
            name={'Відправити'}
            type={'submit'}
            inverted={true}
          ></Button>
        </form>
      </div>
    </>
  );
}
